import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { DividerModule } from 'primeng/divider';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { TabsModule } from 'primeng/tabs';
import { SkeletonModule } from 'primeng/skeleton';
import { ChipModule } from 'primeng/chip';
import { MultiSelectModule } from 'primeng/multiselect';
import { AccordionModule } from 'primeng/accordion';
import { DialogModule } from 'primeng/dialog';
import { AutoCompleteModule } from 'primeng/autocomplete';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
  DynamicDialogModule
} from 'primeng/dynamicdialog';
import { TooltipModule } from 'primeng/tooltip';
import { FileUploadModule } from 'primeng/fileupload';
import { ChartModule } from 'primeng/chart';
import { ToolbarModule } from 'primeng/toolbar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PopoverModule } from 'primeng/popover';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectModule } from 'primeng/select';

const PRIMENG_MODULES = [
  ButtonModule,
  CardModule,
  TableModule,
  SelectModule,
  DividerModule,
  InputTextModule,
  CheckboxModule,
  DialogModule,
  ChipModule,
  DynamicDialogModule,
  AutoCompleteModule,
  ProgressBarModule,
  ProgressSpinnerModule,
  ToastModule,
  TabsModule,
  SkeletonModule,
  MultiSelectModule,
  AccordionModule,
  PopoverModule,
  TooltipModule,
  FileUploadModule,
  ChartModule,
  DatePickerModule,
  AutoCompleteModule,
  ToolbarModule,
  ConfirmDialogModule,
  InputGroupModule,
  InputGroupAddonModule
];

@NgModule({
  declarations: [],
  imports: [...PRIMENG_MODULES],
  exports: [...PRIMENG_MODULES],
  providers: [DialogService, DynamicDialogConfig, DynamicDialogRef]
})
export class PrimengExportsModule {}
